import styled from 'styled-components';

export const ScJackpotMessage = styled.div`
  cursor: pointer;
  padding: 16px;
  border-radius: 16px;
  background: ${({ theme }) => theme.whiteColor};
  margin-bottom: 16px;
  gap: 16px;
  align-items: center;

  display: grid;
  grid-template-columns: 24px 1fr 24px;

  svg:last-child {
    transform: rotate(-90deg);
  }

  p {
    color: ${({ theme }) => theme.blackColor};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.14px;
  }
`;
